module.exports = __webpack_public_path__ + "img/comment_3.8563ef69.png";